import React from 'react';
import { inputPropTypes } from './InputPropTypes';
const Input = ({
  name,
  required,
  placeholder,
  classname,
  onChange,
  value,
  type
}) => {
  return /*#__PURE__*/React.createElement("input", {
    id: name,
    value: value,
    name: name,
    placeholder: placeholder,
    onChange: onChange,
    type: type,
    min: type === 'number' ? 0 : null,
    required: required || null,
    className: classname || ''
  });
};
export default Input;